<script>
	import CertificationTypeList from '@components/certifications/CertificationTypeList.vue';
	import CertificationTypeEditor from '@components/certifications/CertificationTypeEditor.vue';
	import { mapActions, mapGetters } from 'vuex';
	import CertificationsTable from '@components/certifications/CertificationsTable.vue';
	import CertificationUploader from '@components/certifications/CertificationUploader.vue';
	import CertificationDialog from '@components/certifications/CertificationDialog.vue';

	export default {
		name: 'PageCertifications',
		components: { CertificationUploader, CertificationsTable, CertificationTypeEditor, CertificationsTypeList: CertificationTypeList, CertificationDialog },
		data() {
			return {
				isCertUploaderOpen: false,
				editingCertTypeId: undefined,
				editingEmployeeId: undefined,
				showCertificationDialog: false,
				editingCertification: undefined
			};
		},
		computed: {
			...mapGetters({
				certificationTypes: 'certificationTypes/getTypes',
				certifications: 'certifications/getCertifications',
				certificationsExpiringSoon: 'certifications/expiringSoon',
				certificationsExpired: 'certifications/expired',
				loggedInEmployee: 'loggedInEmployee',
				loggedInEmployeeIsAdminOrManager: 'loggedInEmployeeIsAdminOrManager'
			}),
			certsExpiringAndExpired() {
				return [...this.certificationsExpiringSoon, ...this.certificationsExpired];
			},
			isAdmin() {
				return this.loggedInEmployee && this.loggedInEmployee.isAdmin;
			}
		},
		methods: {
			...mapActions({
				initializeCertificationTypes: 'certificationTypes/initialize',
				initializeCertifications: 'certifications/initialize',
				upsertCertificationType: 'certificationTypes/upsert'
			}),
			onUpdateClick(cert) {
				this.editingCertTypeId = cert.certificationTypeId;
				this.editingEmployeeId = cert.employeeId;
				this.isCertUploaderOpen = true;
			},
			onCertificationAdded(cert) {
				this.editingCertification = cert;
				this.showCertificationDialog = true;
			},
			onAddNewClick() {
				this.editingEmployeeId = undefined;
				this.editingCertTypeId = undefined;
				this.isCertUploaderOpen = true;
			},
			onCertificationUpdated(updatedCertification) {
				this.editingCertification = updatedCertification;
			}
		},
		async created() {
			await this.$store.dispatch('setPageTitle', 'Certifications');

			await Promise.all([this.initializeCertificationTypes(), this.initializeCertifications()]);
		}
	};
</script>

<template>
	<div>
		<v-layout row align-end mb-3>
			<v-flex grow>
				<v-layout style="gap:1rem">
					<v-flex xs6 sm3>
						<v-card :class="['certification-card card-expired', certificationsExpired.length > 0 ? 'highlighted' : '']">
							<v-card-text class="d-flex justify-content-between align-center">
								<h3 class="text-xs-left">Expired</h3>
								<h1 class="text-xs-right">{{ certificationsExpired.length }}</h1>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex xs6 sm3>
						<v-card :class="['certification-card card-expiring', certificationsExpiringSoon.length > 0 ? 'highlighted' : '']">
							<v-card-text class="d-flex justify-content-between align-center">
								<h3 class="text-xs-left">Expiring Soon
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon small v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                                        </template>
                                        <span>Certifications expiring in the next 14 days</span>
                                    </v-tooltip>
                                </h3>
								<h1 class="text-xs-right">{{ certificationsExpiringSoon.length }}</h1>
							</v-card-text>
						</v-card>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>

		<v-layout>
			<v-flex>
				<CertificationsTable @onUploadNewClick="isCertUploaderOpen = true" @onUpdateClick="onUpdateClick" />
			</v-flex>
		</v-layout>

		<CertificationUploader :value="isCertUploaderOpen" @input="isCertUploaderOpen = $event" :employee-id="editingEmployeeId" :certification-type-id="editingCertTypeId" @onCertificationAdded="onCertificationAdded" />

		<!-- <v-footer color="" app height="55">
			<v-spacer></v-spacer>
			<v-btn v-if="loggedInEmployeeIsAdminOrManager" @click="onAddNewClick" color="primary"><v-icon class="mr-2">add</v-icon>Add Certification</v-btn>
		</v-footer> -->
		<certification-dialog v-if="showCertificationDialog" :certification="editingCertification" @closeDialog="showCertificationDialog = false" @onCertificationUpdated="onCertificationUpdated" />
	</div>
</template>

<style scoped>
	.certification-card {
		border-left: 4px solid transparent;
		color: #000;
	}

	.card-expired {
		border-left-color: #ff5722;
	}

	.card-expiring {
		border-left-color: #ffa000;
	}

	.highlighted.card-expired {
		background-color: #ffeceb;
	}

	.highlighted.card-expiring {
		background-color: #fff8e1;
	}
</style>
